import Text from './text/text';
import Image from './image/image';
import TextVariant from './text/text-variant';
import ProductListing from "./product-listing";
import CategoryHeader from "../../page/category/header";
import MainBanner from './text-and-image/newport-main-banner';
import CategoryMenu from "./menu/category-menu";
import SlimAaronsBarker from "./text-and-image/slim-aarons-barker";
import VoyadoProductBlock from "./commerce/voyado-product-block";

export default {
	'text': Text,
	'image-text': CategoryHeader,
	'newport-text-variant-1': TextVariant,
	'newport-text-variant-2': TextVariant,
	'newport-text-variant-3': TextVariant,
	'newport-main-banner': MainBanner,
	'slim-aarons-barker': SlimAaronsBarker,
	'newport-image': Image,
	'category-menu': CategoryMenu,
	'product-listing': ProductListing,
	'voyado-product-block': VoyadoProductBlock
};